import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const HelpTip = ({ title, children, testId = "help-tip" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" data-testid={testId} aria-label={`Ajuda: ${title}`}
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-500/10 text-amber-500 hover:bg-amber-500/25 transition-colors align-middle">
        <HelpCircle className="w-3.5 h-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent className="max-w-xs text-sm leading-relaxed" side="top">
      <p className="font-display font-semibold mb-1">{title}</p>
      <p className="text-muted-foreground">{children}</p>
    </PopoverContent>
  </Popover>
);
